import { render, staticRenderFns } from "./ModelViewer.vue?vue&type=template&id=0958119f&scoped=true"
import script from "./ModelViewer.vue?vue&type=script&lang=js"
export * from "./ModelViewer.vue?vue&type=script&lang=js"
import style0 from "./ModelViewer.vue?vue&type=style&index=0&id=0958119f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958119f",
  null
  
)

export default component.exports